import { SelectItem } from '@components/inputs/select/Select.component';
import { Locales } from '@constants/locales.constants';
import { Pagination } from '@store/common/pagination.model';
import { TableFilter, TableFilterType } from '@store/common/tableFilter.model';
import { UserLight } from '@store/settings/users';
import I18n from '@utils/i18n.utils';


export enum AuditsStatusTab {
    ALL = 'ALL',
    PENDING = 'PENDING',
    FINISHED = 'FINISHED'
}

export enum AuditsStatus {
    PREAUDIT = 'PREAUDIT',
    AUDIT = 'AUDIT',
    RECOMMENDATION = 'RECOMMENDATION',
    OFFER = 'OFFER',
    FINISHED = 'FINISHED'
}

export namespace AuditsStatus {
    export const selectItems = (): SelectItem[] => [
        {label: I18n.t('global.AuditOperationStatusEnum.rejected'), value: AuditsStatus.PREAUDIT},
        {label: I18n.t('global.AuditOperationStatusEnum.active'), value: AuditsStatus.AUDIT},
        {label: I18n.t('global.AuditOperationStatusEnum.blocked'), value: AuditsStatus.RECOMMENDATION},
        {label: I18n.t('global.AuditOperationStatusEnum.archived'), value: AuditsStatus.OFFER},
        {label: I18n.t('global.AuditOperationStatusEnum.archived'), value: AuditsStatus.FINISHED},
    ];
}

export interface AuditsPagination extends Pagination {
    data: Audit[];
}

export namespace AuditsFilters {
    export const initTableFilters = () =>
        TableFilterType.initTableFilters([
            TableFilterType.STATUS,
        ]);
}

export interface AuditsFilters {
    search: string;
    status?: AuditsStatus;
    sortBy?: string;
    orderBy?: string;
    tableFilters: TableFilter[];
}

export interface AuditUI {
    id: number;
    selected: boolean;
}

export interface Audit {
    id: number;
    name: string;
    status: AuditsStatus;
    clientOrganisationUnit: string;
    clientOrganisationUnitId: number;
    clientOrganisation: string;
    clientOrganisationId: number;
    participants?: string;
    updatedAt: Date;
    users?: UserLight[];
}

export interface CreateAuditDto {
    name: string;
    clientOrganisationUnitId: number;
    auditTemplateId?: number;
    defaultLanguage: Locales;
}

export interface UpdateAuditDto {
    name?: string;
    clientOrganisationUnitId?: number;
}


export interface MergeAuditDto {
    firstAuditId: number;
    secondAuditId: number;
}

export interface CreateAuditDto {
    name: string;
    clientOrganisationUnitId: number;
}

export interface CreateAuditDto {
    name: string;
    clientOrganisationUnitId: number;
}

